module.exports = __webpack_public_path__ + "img/attachment-logo.a4cfd0ba.svg";